import { Text as CKText, TextProps as CKTextProps } from '@chakra-ui/react';

type TextTypeProps = {
  type?: 'label' | 'body';
};

type Props = CKTextProps & TextTypeProps;

export const Text = ({ type, ...props }: Props) => {
  const variant = type === 'label' ? 'label' : undefined;

  return <CKText variant={variant} {...props} />;
};
